module.exports = __webpack_public_path__ + "static/media/dunnage2.c93b0a8e.png";